import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isUndefined } from 'lodash';

import ScrollArea from '../ScrollArea/ScrollArea';

import './Select.css';

const DROPDOWN_MIN_HEIGHT = 5 * 32 // 5 items of 32 pixels

export default class Select extends React.PureComponent {
    static propTypes = {
        items: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
                caption: PropTypes.node.isRequired,
            }),
        ).isRequired,
        gtmTag: PropTypes.string,
        selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        isDisabled: PropTypes.bool,
        isLanguage: PropTypes.bool,
        zIndex: PropTypes.number,

        isChangeGameVersionMod: PropTypes.bool,

        onItemChange: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            isOpened: false,
        }
    }

    componentDidMount() {
        window.addEventListener('click', this.handleOutsideClick, true)
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.handleOutsideClick, true)
    }

    handleChange(selectedValue) {
        if (this.gtmTagRef) {
            this.gtmTagRef.click()
        }
        this.props.selectedValue !== selectedValue && this.props.onItemChange(selectedValue)
        this.hide()
    }

    handleOutsideClick = (event) => {
        if (!this._base.contains(event.target)) {
            this.hide()
        }
    }

    show = () => {
        this.setState({ isOpened: true })
    }

    hide = () => {
        this.setState({ isOpened: false })
    }

    handleToggle = () => {
        this.state.isOpened ? this.hide() : this.show()
    }

    getSelectText() {
        const selectedValue = this.props.selectedValue

        if (selectedValue) {
            return this.props.items.find(item => (item.value === selectedValue)).caption
        }

        return ''
    }

    renderItems() {
        if (this.props.isChangeGameVersionMod) {
            let slicedVersions = this.props.items;

            if (this.props.items.length > 5)
                slicedVersions = this.props.items.slice(0, 3)

            return slicedVersions.map((item, idx) => {
                const classNameOption = classNames("Select_option", {
                    [`Select_option__${item.value}`]: this.props.isLanguage,
                })

                return (
                    <div
                        key={`item-${idx}`}
                        className={classNameOption}
                        onClick={() => this.handleChange(item.value)}
                    >
                        {item.caption}
                    </div>
                )

            })
        } else {
            return this.props.items.map((item, idx) => {
                const classNameOption = classNames("Select_option", {
                    [`Select_option__${item.value}`]: this.props.isLanguage,
                })

                return (
                    <div
                        key={`item-${idx}`}
                        className={classNameOption}
                        onClick={() => this.handleChange(item.value)}
                    >
                        {item.caption}
                    </div>
                )

            })
        }
    }

    renderGtmTag() {
        return !isUndefined(this.props.gtmTag) ? (
            <div className={classNames(this.props.gtmTag)} ref={c => (this.gtmTagRef = c)} />
        ) : null
    }

    render() {
        const classNameBase = classNames("Select_base", {
            "Select_isOpened": this.state.isOpened,
            "Select_isLanguage": this.props.isLanguage,
            "Select_isDisabled": this.props.isDisabled,
        })

        const classNameValue = classNames("Select_value", {
            "Select_isOpened": this.state.isOpened,
            [`Select_value__${this.props.selectedValue}`]: this.props.isLanguage,
        })

        const otherStyles = (typeof this.props.zIndex !== 'undefined') ? {zIndex: this.props.zIndex+1} : null
        
        return (
            <div
                ref={c => (this._base = c)}
                className={classNameBase}
                style={otherStyles}
                onClick={this.handleToggle}
            >
                {this.renderGtmTag()}
                <div className={classNameValue}>{this.getSelectText()}</div>
                <div className="Select_dropdown">
                    <ScrollArea isDropdown contentHeightMax={DROPDOWN_MIN_HEIGHT}>
                        {this.renderItems()}
                    </ScrollArea>
                </div>
            </div>
        )
    }
}
